import { SmartSendItemGroup } from './SmartSendGroup';
import { CoverExtra, ExtendedBaseCoverExtra } from '../../ExtrasHelper';
import { ExtraBase, QuoteExtraApiModel } from '~/lib/api/smartsend/types';
import { SumNumber, onlyUnique } from '../../../lib/helpers/ArrayHelper';
import { ExtraAlwaysIncluded } from '../../../lib/helpers/ExtraAlwaysIncluded';

export interface ExtrasSummary {
  extra: ExtraBase;
  toAdd?: {
    Price: number;
    Vat: number;
    Total: number;
    Count: number;
  };
  canRemove: boolean;
}

export interface QuoteExtra extends QuoteExtraApiModel {
  Count: number;
}

export const GetBaseItems = (group: SmartSendItemGroup) => {
  // Get full group, or just the selected ones.
  const items = group.Items.filter((x) => x.Status == 'Active');
  const selected = items.filter((x) => x.State?.selected === true);
  if (selected.length > 0) {
    return selected;
  }
  return items;
};

export const GetAvailableExtras = (group: SmartSendItemGroup) => {
  const rawOptions: QuoteExtraApiModel[] = GetBaseItems(group)
    .map((x) => ({
      quote: x.State?.validation?.QuoteState?.Quote?.Options[0],
      service: x.State?.validation?.QuoteState?.Quote?.Service
    }))
    .filter((x) => !!x.quote?.AvailableExtras && !!x.service)
    .flatMap((x) =>
      x.quote.AvailableExtras.filter(
        (a) => !(a.Id === CoverExtra && a.Price == 0) && !ExtraAlwaysIncluded(a.Id, x.service)
      )
    );

  // Only show the full cover if they have £20 on all items
  let ids = rawOptions
    .map((x) => x.Id)
    .filter(onlyUnique)
    .sort();

  if (ids.includes(CoverExtra) && ids.includes(ExtendedBaseCoverExtra)) {
    ids = ids.filter((i) => i != CoverExtra);
  }

  return ids.map((x) => {
    const ofType = rawOptions.filter((o) => o.Id === x);
    return {
      ...ofType[0],
      Total: SumNumber(ofType.map((x) => x.Total)),
      Price: SumNumber(ofType.map((x) => x.Price)),
      Vat: SumNumber(ofType.map((x) => x.Vat)),
      Count: ofType.length
    };
  });
};

export const GetTakenExtras = (group: SmartSendItemGroup) => {
  const rawOptions: QuoteExtraApiModel[] = [];

  GetBaseItems(group)
    .map((x) => x.State?.validation?.QuoteState?.Quote?.Options[0])
    .filter((x) => !!x)
    .forEach((x) => {
      x.Extras.forEach((p) => {
        rawOptions.push(p);
      });
    });

  // Only show the full cover if they have £20 on all items
  const ids = rawOptions
    .map((x) => x.Id)
    .filter(onlyUnique)
    .sort();

  return ids.map((x) => {
    const ofType = rawOptions.filter((o) => o.Id === x);
    return {
      ...ofType[0],
      Total: SumNumber(ofType.map((x) => x.Total)),
      Price: SumNumber(ofType.map((x) => x.Price)),
      Vat: SumNumber(ofType.map((x) => x.Vat)),
      Count: ofType.length
    };
  });
};

export const GenerateSummary = (group: SmartSendItemGroup) => {
  const output: ExtrasSummary[] = [];

  // Get List of Extra which can be added
  const available = GetAvailableExtras(group);

  // Get list of the taken extras and allow the user to remove
  const taken = []; // GetTakenExtras(group);

  available.forEach((x) => {
    if (!output.find((i) => i.extra.Id == x.Id)) {
      output.push({ extra: x, toAdd: x, canRemove: false });
    }
  });

  taken.forEach((x) => {
    if (!output.find((i) => i.extra.Id == x.Id)) {
      output.push({ extra: x, canRemove: true });
    } else {
      output.forEach((f) => {
        if (f.extra.Id === x.Id) {
          f.canRemove = true;
        }
      });
    }
  });

  return output;
};
